import FirebaseApp from "../../../firebaseApp";

const state = {
  history: []
};
const getters = {
  getHistory(state) {
    return state.history;
  }
};
const mutations = {
  recordCalc(state, payload) {
    state.history.push(payload);
  }
};
const actions = {
  async recordCalc({ commit, rootGetters }, data) {
    await FirebaseApp.db
      .collection("users")
      .doc(rootGetters["auth/userId"])
      .collection("historico")
      .add(data)
      .then(() => {
        commit("recordCalc", data);
      })
      .catch(error => alert("🤕 " + error.message));
  },
  async index({ commit, rootGetters }) {
    let data = null;
    FirebaseApp.db
      .collection("users")
      .doc(rootGetters["auth/userId"])
      .collection("historico")
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          data = doc.data();
          commit("recordCalc", data);
        });
      })
      .catch(error => {
        alert("🤕 " + error.message);
      });
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
